export default __webpack_public_path__ + "static/media/streaks 125.de83ed4b.svg";